/* eslint-disable no-param-reassign */

import React, { FunctionComponent, useMemo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { capitalize, snakeCaseTransform } from 'Helpers/layoutHelpers'
import { ReviewStatus } from 'Types/index'

import { ArtistResponse } from '../ArtistResponse'

import { ReviewDetailsProps } from './props'
import {
  ReviewDetailsContainer,
  ReviewDetailsTitle,
  ReviewDetailsRowInfo,
  AddedTo,
  AddedToPercents,
  AddedToPlaylist,
  AddedToPlaylistCover,
  AddedToPlaylistInfo,
  AddedToPlaylistScore,
  AddedToPlaylistScoreLabel,
  AddedToPlaylistTitle,
  AddedToLabel,
} from './styles'

export const ReviewDetails: FunctionComponent<ReviewDetailsProps> = ({
  reviewDetails,
}) => {
  const { t } = useTranslation()

  const {
    review_status,
    review_feedback,
    comment,
    curator_rating,
    addedTo,
  } = reviewDetails

  const isReviewed = useMemo(() => review_status === ReviewStatus.reviewed, [
    review_status,
  ])

  return (
    <ReviewDetailsContainer>
      {isReviewed && (
        <>
          <ReviewDetailsTitle>
            {t('reviewsPage.curatorReview')}
          </ReviewDetailsTitle>
          <ReviewDetailsRowInfo>{comment}</ReviewDetailsRowInfo>
          {addedTo && (
            <>
              <AddedToLabel>{t('reviewsPage.addedToPlaylist')}</AddedToLabel>
              <AddedTo>
                <AddedToPlaylist>
                  <AddedToPlaylistCover src={addedTo.playlist_cover} />
                  <AddedToPlaylistInfo>
                    <AddedToPlaylistTitle>
                      {addedTo.playlist_name}
                    </AddedToPlaylistTitle>
                    <AddedToPlaylistScore>
                      <AddedToPlaylistScoreLabel>
                        {t('reviewsPage.score')}:
                      </AddedToPlaylistScoreLabel>
                      {addedTo.score}
                    </AddedToPlaylistScore>
                  </AddedToPlaylistInfo>
                </AddedToPlaylist>
                <AddedToPercents percent={addedTo.matched_percent}>
                  {addedTo.matched_percent}% {t('reviewsPage.match')}
                </AddedToPercents>
              </AddedTo>
            </>
          )}
          <ArtistResponse
            reviewFeedback={review_feedback}
            curatorRating={curator_rating}
            isModal
          />
        </>
      )}
    </ReviewDetailsContainer>
  )
}
